var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/edit-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.75 16.5H2.25C1.9425 16.5 1.6875 16.245 1.6875 15.9375C1.6875 15.63 1.9425 15.375 2.25 15.375H15.75C16.0575 15.375 16.3125 15.63 16.3125 15.9375C16.3125 16.245 16.0575 16.5 15.75 16.5Z",
    fill: "#000624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.2649 2.61317C12.8099 1.15817 11.3849 1.12067 9.89243 2.61317L8.98493 3.52067C8.90993 3.59567 8.87993 3.71567 8.90993 3.82067C9.47993 5.80817 11.0699 7.39817 13.0574 7.96817C13.0874 7.97567 13.1174 7.98317 13.1474 7.98317C13.2299 7.98317 13.3049 7.95317 13.3649 7.89317L14.2649 6.98567C15.0074 6.25067 15.3674 5.53817 15.3674 4.81817C15.3749 4.07567 15.0149 3.35567 14.2649 2.61317Z",
    fill: "#000624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.7073 8.64906C11.4898 8.54406 11.2798 8.43906 11.0773 8.31906C10.9123 8.22156 10.7548 8.11656 10.5973 8.00406C10.4698 7.92156 10.3198 7.80156 10.1773 7.68156C10.1623 7.67406 10.1098 7.62906 10.0498 7.56906C9.80225 7.35906 9.52475 7.08906 9.27725 6.78906C9.25475 6.77406 9.21725 6.72156 9.16475 6.65406C9.08975 6.56406 8.96225 6.41406 8.84975 6.24156C8.75975 6.12906 8.65475 5.96406 8.55725 5.79906C8.43725 5.59656 8.33225 5.39406 8.22725 5.18406C8.08958 4.88906 7.70239 4.80142 7.4722 5.03162L3.25475 9.24906C3.15725 9.34656 3.06725 9.53406 3.04475 9.66156L2.63975 12.5341C2.56475 13.0441 2.70725 13.5241 3.02225 13.8466C3.29225 14.1091 3.66725 14.2516 4.07225 14.2516C4.16225 14.2516 4.25225 14.2441 4.34225 14.2291L7.22225 13.8241C7.35725 13.8016 7.54475 13.7116 7.63475 13.6141L11.8592 9.38966C12.0847 9.16406 12 8.77591 11.7073 8.64906Z",
    fill: "#000624"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.8854b34dbcf71da969cf2c7befd1bc75.svg";
export { ForwardRef as ReactComponent };